import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the CoursesDetail state domain
 */

const selectCoursesDetailDomain = state => state.coursesDetail || initialState;

/**
 * Other specific selectors
 */

const makeSelectLoading = () =>
  createSelector(
    selectCoursesDetailDomain,
    substate => substate.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectCoursesDetailDomain,
    substate => substate.error,
  );

const makeSelectId = () =>
  createSelector(
    selectCoursesDetailDomain,
    substate => substate.id,
  );

const makeSelectFirstRender = () =>
  createSelector(
    selectCoursesDetailDomain,
    substate => substate.firstRender,
  );

const makeSelectItemData = () =>
  createSelector(
    selectCoursesDetailDomain,
    substate => substate.itemData,
  );

/**
 * Default selector used by CoursesDetail
 */

const makeSelectCoursesDetail = () =>
  createSelector(
    selectCoursesDetailDomain,
    substate => substate,
  );

export default makeSelectCoursesDetail;
export {
  selectCoursesDetailDomain,
  makeSelectId,
  makeSelectFirstRender,
  makeSelectLoading,
  makeSelectError,
  makeSelectItemData,
};
